import styled from 'styled-components'
import { cardSurface } from '@components/Card'
import { CardTitle } from '@components/Heading'
import { textMuted } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { text } from '@/theme/typography'

/**
 * A trip I asked to join, as a card among my trip cards (iOS keeps them in the
 * same list): the trip cards' surface and phone padding, but no lift — it opens nothing.
 */
export const RequestCard = styled.article`
	${cardSurface}
	display: flex;
	flex-direction: column;
	gap: 12px;

	${media.phone} {
		padding: 20px 16px;
	}
`

/** The status pill, with Cancel or Dismiss level with it on the right. */
export const RequestCardTop = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
`

export const RequestCardText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`

export const RequestTripName = styled(CardTitle)`
	overflow-wrap: anywhere;
`

/** The dates line and the who-decides line, styled alike as on iOS. */
export const RequestLine = styled.span`
	${text.bodySm}
	color: ${textMuted};
`
